import React from "react";

import { Box, Button, TextField, Typography } from "@mui/material";


import * as Api from 'api/api';
// import * as UsersApi from 'api/users';
import { ApiUser } from "api/users";


import * as F from 'tsui/Form';
import PageContents from "components/PageContents";
import { ApiProducts } from "api";




interface UserDetailsTabProps {
    productId: string;
    onClose: () => void;

}


export default function ProductDetailsTab(props: UserDetailsTabProps) {

    const [data, setData] = React.useState<ApiProducts | null>(null);
    let [dataRequested, setDataRequested] = React.useState(false);

    const mounted = React.useRef(false);

    const form = F.useUpdateForm();
    let [error, setError] = React.useState<Error | null>(null);
    const [amountAmd, setAmountAmd] = React.useState('');
    const amountAmdRef = React.useRef('');

    const [amountUsd, setAmountUsd] = React.useState('');
    const amountUsdRef = React.useRef('');

    const [amountRub, setAmountRub] = React.useState('');
    const amountRubRef = React.useRef('');

    const [amount, setAmount] = React.useState([]);
    const amountRef = React.useRef([]);

    const handleLangChange = React.useCallback((event) => {

        let changedAmounts: Array<Object> = [];

        console.log(event.target.value)
        if (event.target.id === 'amd') {
            setAmountAmd(event.target.value);
            amountAmdRef.current = event.target.value;
        }
        if (event.target.id === 'usd') {
            setAmountUsd(event.target.value);
            amountUsdRef.current = event.target.value;
        }
        if (event.target.id === 'rub') {
            setAmountRub(event.target.value);
            amountRubRef.current = event.target.value;
        }

        if (amountAmdRef.current !== '') {
            console.log(amountAmdRef.current)
            changedAmounts.push({
                'amount': parseFloat(amountAmdRef.current),
                'currency': 'AMD',
                'currencyCode': '051'
            });
        }

        if (amountUsdRef.current !== '') {
            changedAmounts.push({
                "amount": parseFloat(amountUsdRef.current),
                'currency': 'USD',
                'currencyCode': '840'
            });
        }

        if (amountRubRef.current !== '') {
            changedAmounts.push({
                "amount": parseFloat(amountRubRef.current),
                'currency': 'RUB',
                'currencyCode': '643'
            });
        }

        setAmount(changedAmounts as any)
        amountRef.current = changedAmounts as any
    }, []);

    const onSubmit = React.useCallback((evt: F.InputFormEvent) => {

        Api.requestSessionJson<any>('products', 'update', { productId: props.productId }, amountRef.current).then(d => {

            props.onClose();
        }).catch(err => console.log(err));


    }, []);


    React.useEffect(() => {
        mounted.current = true;
        if (!dataRequested) {
            Api.requestAdmin<ApiProducts>('products', 'get', { productId: props.productId }).then(product => {
                console.log('sss')
                if (mounted.current) {
                    console.log('ssss')
                    console.log('products', product)
                    setData(product);
                }
            }).catch(setError);
            setDataRequested(true);
            return;
        }
        return () => { mounted.current = false }
    }, [dataRequested]);




    console.log('props.productId', props.productId)
    if (!data) return <F.PageFormDialog title='User' form={form} size='md' onSubmit={onSubmit} onClose={props.onClose}>
    </F.PageFormDialog>

    console.log(data?.productPrice)
    console.log(data)

    return <F.PageFormDialog title='User' form={form} size='md' onSubmit={onSubmit} onClose={props.onClose}>
        {/* <Form.InputGroup label='Email' form={form} /> */}

        {data!.productPrice.map((item, index) => <Box key={index}>
            <Typography>{item.currencyCode}</Typography>
            <Typography>{item.currency}</Typography>
            {item.currency === 'AMD' && <TextField id="amd" variant="outlined" defaultValue={item.amount} onChange={handleLangChange} />}
            {item.currency === 'USD' && <TextField id="usd" variant="outlined" defaultValue={item.amount} onChange={handleLangChange} />}
            {item.currency === 'RUB' && <TextField id="rub" variant="outlined" defaultValue={item.amount} onChange={handleLangChange} />}

        </Box>)}


    </F.PageFormDialog>

    {/* {userCardsCollection && <UserCardsCollection open={userCardsCollection} selectedValue={selectedValue} userCards={userCardsArray} userId={props.userId} onClose={() => { setUserCardsCollection(false) }} />} */ }

}

